import React, { useEffect, useState } from "react";
import { Bookmark } from "lucide-react";
import { api } from "../api";
import { useAuth } from "../contexts";

export default function BookmarkButton({ targetUserId, className = "" }) {
  const { user } = useAuth();
  const [bookmarked, setBookmarked] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!user || !targetUserId || user.id === targetUserId) return;
    api.get(`/bookmarks/${targetUserId}/status`).then((r) => setBookmarked(!!r.data?.bookmarked)).catch(() => {});
  }, [user, targetUserId]);

  if (!user || user.id === targetUserId) return null;

  const toggle = async () => {
    setBusy(true);
    try {
      if (bookmarked) {
        await api.delete(`/bookmarks/${targetUserId}`);
        setBookmarked(false);
      } else {
        await api.post(`/bookmarks/${targetUserId}`);
        setBookmarked(true);
      }
    } finally { setBusy(false); }
  };

  return (
    <button
      onClick={toggle}
      disabled={busy}
      className={`btn-ghost ${bookmarked ? "text-[var(--accent)] border-[var(--accent)]" : ""} ${className}`}
      data-testid="bookmark-btn"
      title={bookmarked ? "Bookmarked" : "Save for later"}
    >
      <Bookmark size={14} className={bookmarked ? "fill-[var(--accent)]" : ""} />
      {bookmarked ? "Saved" : "Save"}
    </button>
  );
}
